import { Modal, TextField, useTheme } from '@mui/material'
import React, { FC, useEffect, useState } from 'react'
import { workerInfoType } from '../../singleInput/SingleInputMain'
import classes from './WorkerSearchDialog.module.scss'
import { toKanaString } from '../../../utils/functions/kanaFormatting'
import { useGetWorkersByKana } from '../../../hooks/api/workers/useGetWorkersByKana'
import { Buttons } from '../../uikit/atoms/buttons/Buttons'
import SearchIcon from '@mui/icons-material/Search'
import classNames from 'classnames'
import DialogButton from '../../uikit/atoms/buttons/DialogButton'
import { formatWorkerId } from '../../../utils/variables/workerId'
type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>
  setWorkerInfo: React.Dispatch<React.SetStateAction<workerInfoType>>
}

const WorkerSearchDialog: FC<Props> = (props) => {
  const { setIsShow, setWorkerInfo } = props
  const [open, setOpen] = useState(true)
  const [searchWord, setSearchWord] = useState('')
  const [workers, setWorkers] = useState<workerInfoType[]>([])
  const [selectWorker, setSelectWorker] = useState<workerInfoType | null>(null)
  const getWorkers = useGetWorkersByKana()
  const theme = useTheme()
  const handleCancelButtonClick = () => {
    setOpen(false)
    setIsShow(false)
  }
  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchWord(e.target.value)
  }
  const handleFocusInput = () => {
    setSearchWord('')
  }
  const handleBlurInput = async () => {
    // setSearchWord("1234or01234");
    await fetchWorkerList()
  }
  const fetchWorkerList = async () => {
    if (searchWord.length === 0) {
      return
    }
    const halfKanaStr = toKanaString(searchWord)

    const workers = await getWorkers(halfKanaStr)
    setWorkers(workers)
  }
  useEffect(() => {}, [workers, selectWorker])
  const handleSelectWorker = (worker: workerInfoType) => {
    const newWorker = { ...worker, workerId: formatWorkerId(worker.workerId) }
    setSelectWorker(newWorker)
  }
  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: 'none',
        '&:focus-visible': {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div className={classes.formContainer}>
        <div className={classes.searchArea}>
          <div>
            <div>
              <TextField
                label="カナ名"
                variant="standard"
                type="text"
                multiline={false}
                value={searchWord}
                sx={{
                  height: '70px',
                  width: '100px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  //スピンボタンの無効化-効いていない
                  ':global(input[type="number"]::-webkit-outer-spin-button)': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                  ':global(input[type="number"]::-webkit-inner-spin-button)': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },

                  '& .MuiInputBase-input': {
                    color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                    fontSize: '16px',
                    // その他のスタイル設定...
                  },
                  '& label': {
                    color: theme.palette.foreColor.main, // 通常時のラベル色
                    //backgroundColor:"white"
                  },
                  '& label.Mui-focused': {
                    color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
                  },
                  '& .MuiInput-underline:before': {
                    borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
                  },
                  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                    },
                    '&:hover fieldset': {
                      borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                    },
                    '& .MuiInputBase-root': {},
                  },
                }}
                onChange={handleChangeInput}
                onFocus={handleFocusInput}
                onBlur={handleBlurInput}
                placeholder="モリマツ"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className={classes.kanaButton}>
              <Buttons
                disabled={false}
                onClick={fetchWorkerList}
                caption={'検索'}
                icon={<SearchIcon />}
                width={26}
                height={26}
                fontSize={24}
              />
            </div>
          </div>
          <div className={classes.selectedWorker}>
            <p>選択された社員</p>
            <div className={classes.resultArea}>
              {selectWorker && (
                <>
                  <p>{selectWorker.workerId}</p>
                  <p>{selectWorker.workerName}</p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className={classes.resultArea}>
          <p className={classes.title}>検索結果</p>
          <div className={classes.results}>
            {workers.length > 0 ? (
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {workers.map((worker) => (
                  <li
                    key={worker.workerId}
                    className={classNames(classes.resultItem, {
                      [classes.selected]:
                        worker.workerId === selectWorker?.workerId,
                    })}
                    onClick={() => handleSelectWorker(worker)}
                  >
                    <>
                      <p>{worker.workerId}</p>
                      <p>{worker.workerName}</p>
                    </>
                  </li>
                ))}
              </ul>
            ) : (
              <p className={classes.noResult}>検索結果はありません</p>
            )}
          </div>
        </div>
        <div className={classes.buttons}>
          <DialogButton
            label="確定"
            disabled={!selectWorker}
            onClick={() => {
              if (!selectWorker) return
              setWorkerInfo(selectWorker)
              setIsShow(false)
            }}
            mode="yes"
          />
          <DialogButton
            label="キャンセル"
            onClick={() => setIsShow(false)}
            mode="no"
          />
        </div>
      </div>
    </Modal>
  )
}

export default WorkerSearchDialog
